"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DailyActivityWrapper = function DailyActivityWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "selectedMonth", _descriptor, _this);
      _initializerDefineProperty(_this, "selectedYear", _descriptor2, _this);
      _initializerDefineProperty(_this, "currentDay", _descriptor3, _this);
      _initializerDefineProperty(_this, "currentMonth", _descriptor4, _this);
      _initializerDefineProperty(_this, "currentYear", _descriptor5, _this);
      _initializerDefineProperty(_this, "calculating", _descriptor6, _this);
      _initializerDefineProperty(_this, "loading", _descriptor7, _this);
      _initializerDefineProperty(_this, "initialLoad", _descriptor8, _this);
      if (!_this.props.user) {
        _state.AppUI.loadUser();
      }
      (0, _mobx.autorun)(function () {
        if (!_this.initialLoad && (0, _utils.isPresent)(_this.props.todaysDate)) {
          _this.initialLoad = true;
          _this.currentMonth = (0, _moment["default"])(_this.props.todaysDate).format('M') - 1;
          _this.currentYear = (0, _moment["default"])(_this.props.todaysDate).format('Y');
          _this.currentDay = (0, _moment["default"])(_this.props.todaysDate).format('D');
          _this.selectedMonth = _this.currentMonth;
          _this.selectedYear = _this.currentYear;
          _this.loadCalendar();
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (!this.props.store.hasIndexData && this.props.store.requestCount === 0) {
          this.loadCalendar();
        }
      }
    }, {
      key: "selectedDateString",
      get: function get() {
        return "".concat(_constants.Constants.MONTHS[this.selectedMonth], " ").concat(this.selectedYear);
      }
    }, {
      key: "days",
      get: function get() {
        var _this2 = this;
        var month, day;
        var monthStartsOnDayOfWeek = this.startOfSelectedMonth.day(); // 0 is Sunday
        var lastDayOfLastMonth = this.endOfLastMonth.format('D');
        var lastDayOfThisMonth = this.endOfSelectedMonth.format('D');
        var ary = [];
        if (monthStartsOnDayOfWeek === 0) {
          month = this.selectedMonth;
          day = 0;
        } else {
          month = this.selectedMonth === 0 ? 11 : this.selectedMonth - 1;
          day = lastDayOfLastMonth - monthStartsOnDayOfWeek;
        }
        (0, _lodash.each)((0, _lodash.range)(0, 6), function () {
          var daysOfWeekAry = [];
          (0, _lodash.each)((0, _lodash.range)(0, 7), function () {
            if (month === 11 && _this2.selectedMonth === 0 && day >= lastDayOfLastMonth || month < _this2.selectedMonth && day >= lastDayOfLastMonth || month === _this2.selectedMonth && day >= lastDayOfThisMonth) {
              day = 1;
              month = month === 11 ? 0 : month + 1;
            } else {
              day += 1;
            }
            var date = "".concat(_this2.selectedYear, "-").concat(month < 9 ? 0 : '').concat(month + 1, "-").concat(day < 10 ? 0 : '').concat(day);
            var dateString = "".concat(_constants.Constants.MONTHS[month], " ").concat(day);
            daysOfWeekAry.push([month, day, date, dateString]);
          });
          ary.push(daysOfWeekAry);
        });
        return ary;
      }
    }, {
      key: "startOfSelectedMonth",
      get: function get() {
        return (0, _moment["default"])([this.selectedYear, this.selectedMonth]).startOf('month');
      }
    }, {
      key: "endOfSelectedMonth",
      get: function get() {
        return (0, _moment["default"])([this.selectedYear, this.selectedMonth]).endOf('month');
      }
    }, {
      key: "endOfLastMonth",
      get: function get() {
        return (0, _moment["default"])([this.selectedYear, this.selectedMonth]).subtract(1, 'month').endOf('month');
      }
    }, {
      key: "monthIsCurrent",
      get: function get() {
        return this.selectedMonth === this.currentMonth && this.selectedYear === this.currentYear;
      }
    }, {
      key: "calendarWidth",
      get: function get() {
        return (_constants.Theme.XpCalendarDayWidth + _constants.Theme.XpCalendarMargin) * _constants.Theme.XpCalendarNumberWeeks;
      }
    }, {
      key: "loadCalendar",
      value: function loadCalendar() {
        if (this.startOfSelectedMonth && this.endOfSelectedMonth) {
          this.loading = true;
          this.props.store.getIndex({
            ids: {
              userId: this.props.userId
            },
            limit: 32,
            filters: {
              occurred_at: "RANGE[".concat(this.startOfSelectedMonth.toDate().toISOString(), ",").concat(this.endOfSelectedMonth.toDate().toISOString(), "]")
            }
          }, this.afterGetIndex);
        }
      }
    }, {
      key: "afterGetIndex",
      value: function afterGetIndex(resp) {
        this.props.store.setIndexData(resp);
        this.loading = false;
      }
    }, {
      key: "increment",
      value: function increment() {
        if (!this.monthIsCurrent) {
          if (this.selectedMonth === 11) {
            this.selectedMonth = 0;
            this.selectedYear += 1;
          } else {
            this.selectedMonth += 1;
          }
          this.loadCalendar();
        }
      }
    }, {
      key: "decrement",
      value: function decrement() {
        if (this.selectedMonth === 0) {
          this.selectedMonth = 11;
          this.selectedYear -= 1;
        } else {
          this.selectedMonth -= 1;
        }
        this.loadCalendar();
      }
    }, {
      key: "onToggleXpView",
      value: function onToggleXpView() {
        var newXpView = _state.AppUI.user.xpView === 'calendar' ? 'list' : 'calendar';
        _state.AppUI.user.set('xpView', newXpView);
        _state.AppUI.authUserStore.update({
          data: {
            xpView: newXpView
          }
        }, _lodash.noop);
      }
    }, {
      key: "lostStreakYesterday",
      get: function get() {
        var _this$user;
        if ((0, _utils.isPresent)((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.todaysDatetime) && new Date(this.user.todaysDatetime).getHours() > 5 && (0, _utils.isPresent)(this.props.todaysDate) && this.props.store.hasIndexData) {
          var oneDayAgo = (0, _moment["default"])(this.props.todaysDate).subtract(1, 'day').format('YYYY-MM-DD');
          var twoDaysAgo = (0, _moment["default"])(this.props.todaysDate).subtract(2, 'day').format('YYYY-MM-DD');
          var oneDayAgoXpCount = this.props.store.indexData.find(function (item) {
            return item.occurredAt === oneDayAgo;
          });
          var twoDaysAgoXpCount = this.props.store.indexData.find(function (item) {
            return item.occurredAt === twoDaysAgo;
          });
          return ((0, _utils.isBlank)(oneDayAgoXpCount) || oneDayAgoXpCount.xp < oneDayAgoXpCount.dailyXpGoal) && (0, _utils.isPresent)(twoDaysAgoXpCount) && twoDaysAgoXpCount.xp >= twoDaysAgoXpCount.dailyXpGoal;
        }
        return false;
      }
    }, {
      key: "todaysDailyXpCount",
      get: function get() {
        var _this3 = this;
        return this.props.store.hasIndexData && this.props.store.indexData.find(function (item) {
          return item.occurredAt === (0, _moment["default"])(_this3.props.todaysDate).format('YYYY-MM-DD');
        });
      }
    }, {
      key: "summarizedXpBreakdowns",
      value: function summarizedXpBreakdowns(dailyXpCount) {
        var _dailyXpCount$xpBreak;
        var res = [];
        (_dailyXpCount$xpBreak = dailyXpCount.xpBreakdowns) === null || _dailyXpCount$xpBreak === void 0 || _dailyXpCount$xpBreak.forEach(function (xpBreakdown) {
          if (xpBreakdown.xpSlug === 'card-review-deck') {
            var resBreakdown = res.find(function (item) {
              return item.xpSlug === 'card-review-deck' && item.languageId === xpBreakdown.languageId;
            });
            if ((0, _utils.isPresent)(resBreakdown)) {
              resBreakdown['xp'] += xpBreakdown.xp;
            } else {
              res.push((0, _lodash.clone)(xpBreakdown));
            }
          } else {
            res.push((0, _lodash.clone)(xpBreakdown));
          }
        });
        return res;
      }
    }, {
      key: "dayBeforeStreakStart",
      get: function get() {
        var _this$user$currentStr;
        return this.user.currentStreakCount > 0 ? (_this$user$currentStr = this.user.currentStreakStart.momentObj) === null || _this$user$currentStr === void 0 ? void 0 : _this$user$currentStr.clone().subtract(1, 'days') : null;
      }
    }, {
      key: "user",
      get: function get() {
        return (0, _utils.isPresent)(this.props.user) ? this.props.user : _state.AppUI.user;
      }
    }, {
      key: "showStreakExtendFooter",
      get: function get() {
        return (this.user.streakCanBeExtended || this.streakWasExtendedToday) && this.props.store.hasIndexData && (0, _utils.isPresent)(this.todaysDailyXpCount) && this.user.streakExtensionIsAllowed && this.user.distanceFromXpGoal <= 0;
      }
    }, {
      key: "streakWasExtendedToday",
      get: function get() {
        var _this$user2;
        return ((_this$user2 = this.user) === null || _this$user2 === void 0 || (_this$user2 = _this$user2.lastStreakExtendedAt) === null || _this$user2 === void 0 ? void 0 : _this$user2.dashesWithYear) === this.props.todaysDate;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          days: this.days,
          onToggleXpView: this.onToggleXpView,
          calendarWidth: this.calendarWidth,
          increment: this.increment,
          decrement: this.decrement,
          dailyXpGoal: this.props.dailyXpGoal,
          loading: this.loading,
          monthIsCurrent: this.monthIsCurrent,
          selectedMonth: this.selectedMonth,
          selectedYear: this.selectedYear,
          selectedDateString: this.selectedDateString,
          currentMonth: this.currentMonth,
          currentYear: this.currentYear,
          currentDay: this.currentDay,
          lostStreakYesterday: this.lostStreakYesterday,
          loadCalendar: this.loadCalendar,
          summarizedXpBreakdowns: this.summarizedXpBreakdowns,
          dayBeforeStreakStart: this.dayBeforeStreakStart,
          streakExtendGoal: this.user.streakExtendGoal,
          user: this.user,
          showStreakExtendFooter: this.showStreakExtendFooter,
          streakWasExtendedToday: this.streakWasExtendedToday
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedMonth", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedYear", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "currentDay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "currentMonth", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "currentYear", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "calculating", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "loading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "initialLoad", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "selectedDateString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedDateString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "days", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "days"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "startOfSelectedMonth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "startOfSelectedMonth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "endOfSelectedMonth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "endOfSelectedMonth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "endOfLastMonth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "endOfLastMonth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "monthIsCurrent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "monthIsCurrent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "calendarWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "calendarWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetIndex", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetIndex"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "increment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "increment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "decrement", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "decrement"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleXpView", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleXpView"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "lostStreakYesterday", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "lostStreakYesterday"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "todaysDailyXpCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "todaysDailyXpCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "summarizedXpBreakdowns", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "summarizedXpBreakdowns"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dayBeforeStreakStart", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dayBeforeStreakStart"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "user"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showStreakExtendFooter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showStreakExtendFooter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "streakWasExtendedToday", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "streakWasExtendedToday"), _class2.prototype), _class2)) || _class;
};
DailyActivityWrapper.displayName = 'DailyActivityWrapper';
var _default = exports["default"] = DailyActivityWrapper;